<template>
    <div v-if="visible">
        <el-dialog title="批量打印成绩" 
            v-loading="loading"
            :element-loading-text="loadingText"
            element-loading-spinner="el-icon-loading"
            element-loading-background = "rgba(255, 255,255,0.7)"
            :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="850px">    

            <div v-show="isShow" style="z-index: 9999;position:fixed;margin-left:700px;margin-top:300px;">
                <div><el-button type="primary" round  @click="batchPrint" style="width:100px;">打印</el-button></div>
                <div><el-button type="danger"  round  @click="visible=false;" style="width:100px;margin-top:5px;">关闭</el-button></div>
            </div>

            <div id="printContent">
                <div class="page" v-for="(item,index) of dataList" :key="index" :id="'printDiv' + index" style='page-break-before:always'>
                    <div style="text-align:center;font-weight:bold;font-size:18px;">{{title['title'+index]}}</div>
                    <div style="font-size:12px;color:#BBBBBB;text-align:center;">发布老师：{{sendUser['sendUser'+index]}}，发布时间：{{sendDate['sendDate'+index]}}</div>
                    <div style="text-align:center;font-size:16px;margin-top:5px;">姓名:{{item.name}}</div>
                    <el-table
                        :data="content['content'+index]"
                        :header-cell-style="{'text-align':'center'}"
                        :cell-style="{'text-align':'center'}"
                        style="width:100%;margin-bottom:20px;margin-top:8px;"
                        row-key="id"
                        border
                        default-expand-all>
                        <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                        <el-table-column prop="subjectName" label="学科" ></el-table-column>
                        <el-table-column prop="score" label="成绩" ></el-table-column>
                        <el-table-column prop="avgScore" label="平均分" v-if="showAvgScoreSwitch"></el-table-column>
                    </el-table>
                    <div v-if="comment['comment'+index]!=null && comment['comment'+index]!=''">【老师评语】{{comment['comment'+index]}}</div>
                </div>
                
            </div> 
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../common/http'; 
    import print from 'print-js';

    export default {
        data(){
            return{
                loading:false,
                loadingText:"",

                visible: false,
                dataList:[],
                content:{},
                sendDate:{},
                sendUser:{},
                comment:{},
                title:{}, 
                isShow:false,
                // added by ligang 20250512
                showAvgScoreSwitch:false
            }
        },
        created:function () {
        },
        mounted:function () {
        },
        methods:{
            indexMethod(index) {
                return index+1;
            },
            init(data, scoreListData){
                this.visible=true;
                this.isShow=false;
                this.dataList=data;

                // 重置内容：
                this.content={};
                this.sendDate={};
                this.sendUser={};
                this.comment={};
                this.title={}; 
                this.getData();
                
                // 查询是否输出平均分
                this.showAvgScoreSwitch = scoreListData.showAvgScoreSwitch
            },
            getData(){
                this.loading=true;
                this.loadingText="数据加载中...";

                let url  = this.getStudentSubjectScoreListUrl;
                for(let i=0;i<this.dataList.length;i++){
                    let data = {
                        scoreListId:this.dataList[i].scoreListId,
                        userId:this.dataList[i].userId
                    };
                    this.apiPost(url,data).then((res) => {
                        if(res.status==200){
                             this.$set(this.sendUser,'sendUser'+i,res.data.sendUser);
                             this.$set(this.title,'title'+i,res.data.title);
                             this.$set(this.sendDate,'sendDate'+i,res.data.sendDate);
                             this.$set(this.comment,'comment'+i,res.data.comment);
                             this.$set(this.content,'content'+i,res.data.content);
                        }else{
                            this.$commonFn.showTip(res.message,3);
                        }
                        if(i == this.dataList.length-1){
                            this.loading=false;
                            this.isShow=true;
                        }
                    },(err)=>{
                        if(i == this.dataList.length-1){
                            this.loading=false;
                            this.isShow=true;
                        }
                    });
                }
            },
            dialogClose(done){
                done();
                this.$reload;
                this.visible=false;
            },
            batchPrint() {
                // console.log('打印总数：'+this.dataList.length);
                // this.loading=true;
                // this.loadingText="打印中...";
                printJS({
                    printable:'printContent',
                    type:'html',
                    targetStyles:['*'],
                    ignoreElements:['no-print','bc','gb']
                })
                // setTimeout(function() {
                //    this.loading=false
                // }, 3000);
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
.page {
    margin: 1cm auto;
    border-radius: 5px;
    background: white;
}
</style>


// WEBPACK FOOTER //
// src/components/page/score/BatchPrintScore.vue